// Service URL for CAS
export const uri = encodeURIComponent(process.env.REACT_APP_URL);

// CAS login URL
export const casUrl = process.env.REACT_APP_CAS_URL;

// backend (CF) API URL
export const apiUrl = process.env.REACT_APP_API;
export const generalApiUrl = process.env.REACT_APP_API_GENERAL;

// Value in milliseconds, when need to request new token from server (each 30 minutes)
export const tokenTimeout = 1800000;

// URL for CBRS Members
export const cbrsMembersUrl = process.env.REACT_APP_CBRS_MEMBERS_SITE;

// Value in milliseconds, when need to request system info from server (each 5 minutes)
export const maintenanceTimeout = 300000;



// WEBPACK FOOTER //
// ./src/dictionaries/Env.js